import { render } from "./DatasetTableView.vue?vue&type=template&id=bad56f34"
import script from "./DatasetTableView.vue?vue&type=script&lang=js"
export * from "./DatasetTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__